module.exports = __webpack_public_path__ + "static/media/xlogo.1092570c.png";